export class AddPoint {
    memberId: number;
    taskId: number;
    points: number;
    currentUser: string;
  } 